import { Endpoints } from "../constants/endpoint";

export const GetAllTags = async () => {
  try {
    const res = await fetch(Endpoints.tags);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return await res.json();
  } catch (err) {
    return err.message;
  }
};

export const CreateTag = async (payload) => {
  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify(payload),
  };
  try {
    const res = await fetch(Endpoints.tags, options);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return await res.json();
  } catch (err) {
    return err.message;
  }
};

export const UpdateTag = async (payload, id) => {
  const options = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify(payload),
  };
  try {
    const res = await fetch(Endpoints.tags + id, options);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return await res.json();
  } catch (err) {
    return err.message;
  }
};

export const DeleteTag = async (id) => {
  const options = {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=utf-8",
    },
  };
  try {
    const res = await fetch(Endpoints.tags + id, options);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return await res.json();
  } catch (err) {
    return err.message;
  }
};
